module.exports = __webpack_public_path__ + "static/media/Up-Late-Article-Banner@2x.4dd4b85b.webp";